// src/pages/AdminPage.js
import React, { useState, useEffect } from 'react';
import ProductManager from '../components/ProductManager';

function AdminPage() {
    // Estado para el formulario de CREACIÓN
    const [createFormData, setCreateFormData] = useState({ cedulaUsuario: '', orderId: '', description: '', status: 0 });
    const [createMessage, setCreateMessage] = useState('');

    // Estado para la sección de ACTUALIZACIÓN
    const [searchData, setSearchData] = useState({ cedula: '', orderId: '' });
    const [editData, setEditData] = useState(null); // Guardará los datos del pedido encontrado
    const [updateMessage, setUpdateMessage] = useState('');

    // --- LÓGICA PARA CREAR PEDIDOS ---
    const handleCreateChange = (e) => setCreateFormData({ ...createFormData, [e.target.name]: e.target.value });


    //Estado para tabla clientes
    const [clientes, setClientes] = useState([]);
    const [clientesLoading, setClientesLoading] = useState(false);
    const [clientesError, setClientesError] = useState('');

    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        setCreateMessage('Creando pedido...');
        try {
            const response = await fetch('https://kifli-api.onrender.com/api/orders', {
            //const response = await fetch('http://localhost:5000/api/orders', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(createFormData),
            });
            const data = await response.json();
            setCreateMessage(data.message);
            if (response.ok) setCreateFormData({ cedulaUsuario: '', orderId: '', description: '', status: 0 });
        } catch (error) { setCreateMessage('Error de conexión.'); }
    };

    // --- LÓGICA PARA ACTUALIZAR PEDIDOS ---
    const handleSearchChange = (e) => setSearchData({ ...searchData, [e.target.name]: e.target.value });

    const handleSearchSubmit = async (e) => {
        e.preventDefault();
        setUpdateMessage('Buscando pedido...');
        setEditData(null);
        try {
            const { cedula, orderId } = searchData;
            const response = await fetch(`https://kifli-api.onrender.com/api/users/${cedula}/orders/${orderId}`);
            const data = await response.json();
            if (response.ok) {
                setEditData(data);
                setUpdateMessage('Pedido encontrado. Puedes editarlo a continuación.');
            } else {
                setUpdateMessage(data.message);
            }
        } catch (error) { setUpdateMessage('Error de conexión.'); }
    };
    
    const handleEditChange = (e) => setEditData({ ...editData, [e.target.name]: e.target.value });

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setUpdateMessage('Actualizando pedido...');
        try {
            const { cedula, orderId } = searchData;
            const response = await fetch(`https://kifli-api.onrender.com/api/users/${cedula}/orders/${orderId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ description: editData.description, status: editData.status }),
            });
            const data = await response.json();
            setUpdateMessage(data.message);
            if (response.ok) setEditData(null); // Oculta el formulario de edición tras el éxito
        } catch (error) { setUpdateMessage('Error de conexión.'); }
    };

    //Funcion tabla clientes:
    const fetchClientes = async () => {
        setClientesLoading(true);
        setClientesError('');
    
        try {
            const response = await fetch('https://kifli-api.onrender.com/api/users');
            const data = await response.json();
    
            if (response.ok) {
                setClientes(data);
            } else {
                setClientesError(data.message || 'Error al cargar clientes');
            }
        } catch (error) {
            setClientesError('Error de conexión');
        } finally {
            setClientesLoading(false);
        }
    };

    useEffect(() => {
        fetchClientes();
    }, []);
    return (
        <div className="max-w-6xl mx-auto px-8 pt-10 pb-10 space-y-12">
            <h1 className="text-4xl font-bold">Panel de Administrador</h1>
            
            {/* Formulario de CREAR Pedido */}
            <form onSubmit={handleCreateSubmit} className="bg-[#292929] p-8 rounded-lg space-y-6">
                <h2 className="text-2xl font-semibold text-white">Crear Nuevo Pedido</h2>
                <input name="cedulaUsuario" value={createFormData.cedulaUsuario} onChange={handleCreateChange} required className="input-field px-4" placeholder="Cédula del Usuario" />
                <input name="orderId" value={createFormData.orderId} onChange={handleCreateChange} required className="input-field px-4" placeholder="Número de Orden (ej: 1003)" />
                <input name="description" value={createFormData.description} onChange={handleCreateChange} required className="input-field px-4" placeholder="Descripción del Pedido" />
                <div>
                    <label className="block text-gray-400 mb-2">Estado del Pedido (Status: {createFormData.status}%)</label>
                    <input name="status" type="range" min="0" max="100" step="25" value={createFormData.status} onChange={handleCreateChange} className="w-full" />
                </div>
                <button type="submit" className="form-button bg-lime-400 text-black">Crear Pedido</button>
                {createMessage && <p className="text-center text-white mt-4">{createMessage}</p>}
            </form>

            {/* Sección de ACTUALIZAR Pedido */}
            <div className="bg-[#292929] p-8 rounded-lg space-y-6">
                <h2 className="text-2xl font-semibold text-white">Actualizar Pedido Existente</h2>
                {/* Formulario de Búsqueda */}
                <form onSubmit={handleSearchSubmit} className="flex flex-col md:flex-row gap-4">
                    <input name="cedula" value={searchData.cedula} onChange={handleSearchChange} required className="input-field px-4" placeholder="Cédula del Usuario" />
                    <input name="orderId" value={searchData.orderId} onChange={handleSearchChange} required className="input-field px-4" placeholder="Número de Orden" />
                    <button type="submit" className="form-button bg-cyan-600 text-white">Buscar</button>
                </form>

                {/* Formulario de Edición (aparece si se encuentra un pedido) */}
                {editData && (
                    <form onSubmit={handleUpdateSubmit} className="border-t border-gray-700 pt-6 space-y-6">
                        <h3 className="text-xl text-white">Editando Pedido #{editData.id}</h3>
                        <input name="description" value={editData.description} onChange={handleEditChange} required className="input-field px-4" />
                        <div>
                            <label className="block text-gray-400 mb-2">Nuevo Estado (Status: {editData.status}%)</label>
                            <input name="status" type="range" min="0" max="100" step="25" value={editData.status} onChange={handleEditChange} className="w-full" />
                        </div>
                        <button type="submit" className="form-button bg-lime-400 text-black">Actualizar Pedido</button>
                    </form>
                )}
                {updateMessage && <p className="text-center text-white mt-4">{updateMessage}</p>}
            </div>

            {/* Apartado Tabla clientes */}
            <div className="bg-[#292929] p-8 rounded-lg space-y-6">
                <div className="flex justify-between items-center">
                    <h2 className="text-2xl font-semibold text-white">Clientes</h2>
                    <button 
                        onClick={fetchClientes}
                        className="form-button bg-cyan-600 mx-10 text-white"
                    >
                        Recargar
                    </button>
                </div>
            
                {clientesLoading && <p className="text-white">Cargando clientes...</p>}
                {clientesError && <p className="text-red-400">{clientesError}</p>}
            
                {!clientesLoading && clientes.length > 0 && (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-white">
                          <thead>
                            <tr className="border-b border-gray-600">
                                <th className="py-2 px-4">Cédula</th>
                                <th className="py-2 px-4">Nombre</th>
                                <th className="py-2 px-4">Apellido</th>
                                <th className="py-2 px-4">Email</th>
                                <th className="py-2 px-4">Teléfono</th>
                            </tr>
                            </thead>
                           <tbody>
                                {clientes.map((cliente) => (
                                    <tr key={cliente.cedula} className="border-b border-gray-800">
                                        <td className="py-2 px-4">{cliente.cedula}</td>
                                        <td className="py-2 px-4">{cliente.nombre}</td>
                                        <td className="py-2 px-4">{cliente.apellido}</td>
                                        <td className="py-2 px-4">{cliente.email}</td>
                                        <td className="py-2 px-4">{cliente.telefono}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

                    
            <ProductManager/>
        </div>
    );
}

export default AdminPage;
